module.exports = __webpack_public_path__ + "eb1d6ddd514f5c4771aabb61fb9b8188.fbx";